import "core-js/modules/es.number.constructor.js";
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      num: this.value
    };
  },
  watch: {
    value: function value(val) {
      this.num = val;
    }
  },
  methods: {
    handleChange: function handleChange(val) {
      if (val === '') {
        this.num = this.min;
      }
      if (val < this.min) {
        this.num = this.min;
      }
      if (val > this.max) {
        this.num = this.max;
      }
      this.$emit('input', this.num);
    }
  }
};